/* Progressive collection filtering. No requests, cart or analytics changes.
   Flikar (Alla produkter, Elias val 12/10): data-vk-default = startfliken, data-vk-limit = högst så många
   kort per flik innan «Visa fler», data-vk-only = rad som bara syns i en viss flik. Utan dem: som förut. */
(() => {
  const init = (root) => {
    if (root.dataset.vkReady) return;
    const filters = root.querySelector('[data-vk-filters]');
    const cards = [...root.querySelectorAll('[data-vk-category]')];
    if (!filters || !cards.length) return;
    const buttons = [...filters.querySelectorAll('[data-vk-filter]')];
    const count = root.querySelector('[data-vk-result-count]');
    const more = root.querySelector('[data-vk-more]');
    const moreCount = root.querySelector('[data-vk-more-count]');
    const onlyFor = [...root.querySelectorAll('[data-vk-only]')];
    const fallback = root.dataset.vkDefault || 'all';
    const limit = parseInt(root.dataset.vkLimit, 10) || 0;
    let current = fallback;
    const inTab = (card, category) => category === 'all' || card.dataset.vkCategory.split(' ').includes(category);
    // Diskret rörelse (Elias val 12/10, punkt 13): korten tonar mjukt in (.vk-tona, CSS i sektionen,
    // av vid «minska rörelse»). 'all' = alla synliga kort vid flikbyte, 'new' = bara nya vid Visa fler.
    const tona = (els) => {
      try {
        els.forEach(el => el.classList.remove('vk-tona'));
        void root.offsetWidth;
        els.forEach(el => el.classList.add('vk-tona'));
      } catch (e) { /* bara utseende */ }
    };
    const apply = (category, showAll, animate) => {
      if (!buttons.some(b => b.dataset.vkFilter === category)) category = fallback;
      current = category;
      let matched = 0;
      const shown = [];
      cards.forEach(card => {
        const match = inTab(card, category);
        if (match) matched += 1;
        const wasHidden = card.hidden;
        card.hidden = !match || (!showAll && limit > 0 && matched > limit);
        if (!card.hidden && (animate === 'all' || (animate === 'new' && wasHidden))) shown.push(card);
      });
      if (shown.length) tona(shown);
      buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.vkFilter === category)));
      count.textContent = matched;
      if (more) {
        const rest = showAll || !limit ? 0 : Math.max(0, matched - limit);
        more.hidden = rest === 0;
        if (moreCount) moreCount.textContent = rest;
      }
      onlyFor.forEach(el => { el.hidden = el.dataset.vkOnly !== category; });
    };
    buttons.forEach(button => button.addEventListener('click', () => {
      const category = button.dataset.vkFilter;
      apply(category, false, 'all');
      history.replaceState(null, '', location.pathname + location.search + (category === fallback ? '' : '#' + category));
    }));
    if (more) more.addEventListener('click', () => {
      const firstHidden = cards.find(card => card.hidden && inTab(card, current));
      apply(current, true, 'new');
      const link = firstHidden && firstHidden.querySelector('.vk-apcard__name a');
      if (link) link.focus({ preventScroll: true });
    });
    root.dataset.vkReady = 'true';
    filters.hidden = false;
    apply(location.hash.slice(1), false);
    window.addEventListener('hashchange', () => apply(location.hash.slice(1), false));
  };
  document.querySelectorAll('[data-vk-shop-guide]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-vk-shop-guide]').forEach(init));
})();
